<template lang="">
    <div class="container mx-auto w-full">
		<!-- <div class="text-2xl font-semibold p-4">Профиль</div> -->
        <div class="flex flex-col gap-1">
            <div v-if="!is_loading" class="flex flex-col gap-4 w-full px-2 pr-6 pb-48 bg-stone-100 dark:bg-stone-700">
                <div class="flex flex-col gap-1 w-full">
                    <div class="flex flex-row items-center w-full">
                        <img src="https://img.icons8.com/?size=512w&id=59830&format=png" class="h-4 w-8 px-2">
                        <input v-model="form.first_name" type="text" placeholder="Имя" class="py-2 px-4 text-lg w-full rounded-md dark:bg-stone-500  dark:text-stone-900"/>
                    </div>
                </div>
                
                <div class="flex flex-col gap-1 w-full">
                    <div class="flex flex-row items-center w-full">
                        <img src="https://img.icons8.com/?size=512w&id=59830&format=png" class="h-4 w-8 px-2">
                        <input v-model="form.last_name" type="text" placeholder="Фамилия" class="py-2 px-4 text-lg w-full rounded-md dark:bg-stone-500  dark:text-stone-900"/>
                    </div>
                </div>
                
                <div class="flex flex-col gap-1 w-full">
                    <div class="flex flex-row items-center w-full">
                        <img src="https://img.icons8.com/?size=512w&id=59830&format=png" class="h-4 w-8 px-2">
                        <input v-model="form.middle_name" type="text" placeholder="Отчество" class="py-2 px-4 text-lg w-full rounded-md dark:bg-stone-500  dark:text-stone-900"/>
                    </div>
                </div>

                <div class="p-2">
                    <div class="flex flex-row items-center justify-around">
                        <div class="flex flex-row items-center">
                            <img src="https://img.icons8.com/?size=256w&id=23265&format=png" class="h-6 bg-white rounded-full" />
                            <input type="radio" id="role_passenger" value="passenger" v-model="form.role" class="ml-2 mr-2"/>
                            <label for="role_passenger">{{ loc('passenger') }}</label>
                        </div>
                        <div class="flex flex-row items-center">
                            <img src="https://img.icons8.com/?size=512w&id=3xOrU6jMUB6H&format=png" class="h-6 bg-white rounded-full" />
                            <input type="radio" id="role_transporter" value="transporter" v-model="form.role" class="ml-2 mr-2"/>
                            <label for="role_transporter">{{ loc('transporter') }}</label>
                        </div>
                    </div>
                </div>

                <!-- <div class="pl-8 pt-4">Дата рождения:</div>
                <div class="flex flex-col gap-1 w-full">
                    <div class="flex flex-row items-center w-full">
                        <img src="https://img.icons8.com/?size=512w&id=70151&format=png" class="h-4 w-8 px-2">
                        <input v-model="form.birthday" type="date" placeholder="дата рождения" class="py-2 px-4 text-lg w-full rounded-md dark:bg-stone-500  dark:text-stone-900"/>
                    </div>
                </div> -->

                <!-- <div class="pl-8 pt-4">Контактный телефон:</div>
                <div class="flex flex-col gap-1 w-full">
                    <div class="flex flex-row items-center w-full">
                        <img src="https://img.icons8.com/?size=512w&id=9730&format=png" class="h-4 w-8 px-2">
                        <input v-model="form.contact_phone" type="number" 
                            placeholder="Контактный телефон" 
                            class="py-2 px-4 text-lg w-full rounded-md dark:bg-stone-500  dark:text-stone-900"/>
                    </div>
                </div> -->

                <div v-if="this.$store.state.user?.role == 'transporter'" class="flex flex-col gap-4 pt-0">
                    <!-- <div class="pl-8 pt-4 font-semibold">Для водителей:</div> -->
                    <div class="pl-8 pt-0">Данные автомобиля:</div>
                    
                    <div class="flex flex-col gap-1 w-full">
                        <div class="flex flex-row items-center w-full">
                            <img src="https://img.icons8.com/?size=512w&id=70151&format=png" class="h-4 w-8 px-2">
                            <input v-model="form.car_model" type="text" placeholder="Модель авто" class="py-2 px-4 border-b text-lg w-full rounded-md dark:bg-stone-500  dark:text-stone-900"/>
                        </div>
                    </div>
                    
                    <div class="flex flex-col gap-1 w-full">
                        <div class="flex flex-row items-center w-full">
                            <img src="https://img.icons8.com/?size=512w&id=70151&format=png" class="h-4 w-8 px-2">
                            <input v-model="form.car_color" type="text" placeholder="Цвет" class="py-2 px-4 border-b text-lg w-full rounded-md dark:bg-stone-500  dark:text-stone-900"/>
                        </div>
                    </div>
                    
                    <div class="flex flex-col gap-1 w-full">
                        <div class="flex flex-row items-center w-full">
                            <img src="https://img.icons8.com/?size=512w&id=70151&format=png" class="h-4 w-8 px-2">
                            <input v-model="form.car_plate" type="text" placeholder="Госномер" class="py-2 px-4 border-b text-lg w-full rounded-md dark:bg-stone-500  dark:text-stone-900"/>
                        </div>
                    </div>
                </div>
                
                <div class="flex flex-row justify-center pt-2">
                    <input type="submit" @click="saveForm" value="Сохранить" class="cursor-pointer text-black bg-prime rounded-lg py-2 px-4 text-lg w-1/2 bg-emerald-500 text-white font-semibold"/>
                </div>
                <div class="flex flex-row justify-center py-4 border-t">
                    <input type="submit" @click="logoutUser" value="Выйти из аккаунта" class="cursor-pointer text-black bg-prime rounded-lg py-2 px-8 text-lg bg-rose-500 text-white font-semibold"/>
                </div>
            </div>
            <div v-else class="h-full w-full flex justify-center items-center">
                Загрузка
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            is_loading: false,
            form: {
                first_name: '',
                last_name: '',
                middle_name: '',
                birthday: '',
                role: '',
                car_model: '',
                car_color: '',
                car_plate: '',
            },
            errors: []
        }
    },
    methods: {
        saveForm () {
            this.is_loading = true
            this.postServerData('account_update', { data: this.form })
                .then(()=>{
                    this.$store.dispatch('getUser'); 
                })
                .finally(() => {
                    this.is_loading = false
                })
        },
        updateUserData () {
            if (this.$store.state.user == undefined) return
            this.form.first_name = this.$store.state.user.first_name
            this.form.last_name = this.$store.state.user.last_name
            this.form.middle_name = this.$store.state.user.middle_name
            this.form.birthday = this.$store.state.user.birthday
            this.form.role = this.$store.state.user.role
            this.form.car_model = this.$store.state.user.car_model
            this.form.car_color = this.$store.state.user.car_color
            this.form.car_plate = this.$store.state.user.car_plate
        },
        logoutUser () {
			this.$store.dispatch('logoutUser')
        }
    },
    mounted() {
        this.updateUserData()
    },

}
</script>
<style scoped>
</style>
